import { render, staticRenderFns } from "./goodsEdit.vue?vue&type=template&id=ca0a0b1e&scoped=true&"
import script from "./goodsEdit.vue?vue&type=script&lang=js&"
export * from "./goodsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0a0b1e",
  null
  
)

export default component.exports